import { Component, Input, TemplateRef } from '@angular/core';

export enum TabStatus {
  Error = 'error',
  Info = 'info',
  Warning = 'warning'
}

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.less']
})
export class TabComponent {
  @Input() icon: string = '';
  @Input() heading: string;
  @Input() id: string | number;
  @Input() disabled = false;
  @Input() active = false;
  @Input() status: TabStatus;
  @Input() counter: number = 0;
  @Input() errorCounter: number = 0;
  @Input() link: string = '';
  @Input() templateRef: TemplateRef<unknown>;
  @Input() showCountAlways:boolean=false;

  constructor() {
  }
}
